export default __webpack_public_path__ + "static/media/flag-turkey-active.8a26dc12.svg";